import { Gender } from '@uplift/types';
import { restClient } from '../client';

export type GetGendersResponse = {
  data: Gender[];
};

export const getGenders = () =>
  restClient.request<GetGendersResponse>('/api/v1/genders');